// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");

function make(priceType, price, minPrice, maxPrice) {
  if (priceType === "ExactPrice") {
    if (price !== undefined) {
      return {
              TAG: "Ok",
              _0: {
                exactPrice: {
                  price: Caml_option.valFromOption(price)
                }
              }
            };
    } else {
      return {
              TAG: "Error",
              _0: "error making propertyPriceInput"
            };
    }
  } else if (minPrice !== undefined && maxPrice !== undefined) {
    return {
            TAG: "Ok",
            _0: {
              priceRange: {
                maxPrice: Caml_option.valFromOption(maxPrice),
                minPrice: Caml_option.valFromOption(minPrice)
              }
            }
          };
  } else {
    return {
            TAG: "Error",
            _0: "error making propertyPriceInput"
          };
  }
}

var Schema;

exports.Schema = Schema;
exports.make = make;
/* No side effect */
